import { Specialty } from "@/@types/sintegrada/Specialty";
import { getSintegradaServerApi } from "@/services/api";

type Params = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

type SpecialtyResponse = {
	data: {
		id: number;
		name: string;
		occupation_code: string;
		isActive: boolean;
		createdAt?: string;
		updatedAt?: string;
	}[]
}

export async function getSpecialties(params: Params) {
	const url = `/specialties`;

	const { data } = await getSintegradaServerApi().get<SpecialtyResponse>(url, params);

	return (data?.data || []).map<Specialty>(item => {
		return {
			id: item.id,
			cbo: item.occupation_code,
			isActive: item.isActive,
			name: item.name,
			createdAt: item.createdAt,
			updatedAt: item.createdAt,
		}
	});
}
